import { forwardRef } from "react";
import { MelaInput } from "../MelaInput/MelaInput";
import type { MelaInputProps } from "../MelaInput/MelaInput.types";

// Borders and focus belong to the surrounding editable grid cell.
export const MelaGridInput = forwardRef<HTMLInputElement, MelaInputProps>(
  (props, ref) => (
    <MelaInput
      {...props}
      ref={ref}
      fullWidth
      borderless
      chromeStyle={{
        borderRadius: 0,
        boxShadow: "none",
        background: "transparent",
      }}
    />
  ),
);
